import React from 'react';

import { getUserLocaleName } from '@culture/common-helpers/logic/userLocation';

const InstitutesRedirectPage = () => <p>Пожалуйста, подождите...</p>;

export async function getServerSideProps({ req }) {
	const localeName = await getUserLocaleName(req);

	return {
		redirect: {
			permanent: false,
			destination: `/institutes-catalog/${localeName}`
		},
		props: {}
	};
}

export default InstitutesRedirectPage;
